import { Component, input, OnInit } from '@angular/core';
import {
  RdsBadgeModule,
  RdsTableDataSource,
  RdsTableModule,
} from '@rds/angular-components';
import { RouterLink } from '@angular/router';
import { OfferingRelatedTechnology } from '../../../models/offering';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';
import { RdsLinkModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-offering-related-technology',
  imports: [RdsTableModule, RdsBadgeModule, RouterLink, RdsLinkModule],
  templateUrl: './offering-related-technology.component.html',
  styleUrl: './offering-related-technology.component.scss',
})
export class OfferingRelatedTechnologyComponent implements OnInit {
  relatedTechnology = input<any[]>([]);
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  readonly BUTTONS = BUTTON_TEXTS;

  readonly relatedTechnologyDataSource =
    new RdsTableDataSource<OfferingRelatedTechnology>().init();

  readonly relatedTechnologyColumns = [
    'targetName',
    'description',
    'targetUrl',
  ];

  ngOnInit() {
    this.relatedTechnologyDataSource.data = this.relatedTechnology();
  }
}
